import React, { useEffect, useState } from "react";
import Base from "../admin_components/Admin_Base";
import "../EmployeeSection/Addemployeewalletamount.css";
import { Breadcrumbs } from "@mui/material";
import Link from "@mui/material/Link";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import authAxios from "../Auth/useAxios";
import { ADMIN_API_BASE_URL } from "../Auth/Api"; // Make sure this path is correct

const AddEmployeewalletamount = () => {
  const [formData, setFormData] = useState({
    employeeId: "",
    employeeName: "",
    property: "",
    dateoftransaction: "",
    totalwalletamountavailable: "",
    addamounttowallet: "",
    note: "",
  });

  const [errors, setErrors] = useState({});
  const [employeelist, setEmployeeList] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "employeeId") {
      const selectedEmployee = employeelist.find(
        (emp) => emp.id.toString() === value
      );

      if (selectedEmployee) {
        setFormData({
          ...formData,
          employeeId: selectedEmployee.id,
          employeeName: selectedEmployee.fullName,
          totalwalletamountavailable: selectedEmployee.walletAmount || 0,
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.employeeId) newErrors.employeeId = "Employee is required.";
    if (!formData.property) newErrors.property = "Property Name is required.";
    if (!formData.dateoftransaction)
      newErrors.dateoftransaction = "Date of Transaction is required.";
    if (!formData.totalwalletamountavailable)
      newErrors.totalwalletamountavailable = "Total Wallet Amount is required.";
    if (!formData.addamounttowallet)
      newErrors.addamounttowallet = "Add Amount to Wallet is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      console.log("Form Data:", formData);
      // TODO: Submit formData to API
    } else {
      console.log("Form has errors.");
    }
  };

  useEffect(() => {
    fetchEmployeeList();
  }, []);

  const fetchEmployeeList = async () => {
    try {
      const response = await authAxios.get(
        `${ADMIN_API_BASE_URL}/main/admin/list-employee`
      );
      setEmployeeList(response.data);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  return (
    <Base>
      <div className="pt-3 mt-5 addarea_labels pr-3">
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          <Link
            underline="hover"
            color="inherit"
            href="/admin/dashboard"
            sx={{ color: "darkslategrey", fontWeight: "bold" }}
          >
            Dashboard
          </Link>
          <Link
            underline="hover"
            color="inherit"
            href="/admin/admin_addemployee_walletamount"
            sx={{ color: "darkslategrey", fontWeight: "bold" }}
          >
            Add Employee Wallet Amount
          </Link>
        </Breadcrumbs>
      </div>

      <h2 className="text-center fw-bold main_heading">
        Add Employee Wallet Amount
      </h2>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <hr style={{ width: "94%" }} />
      </div>

      <div className="container mt-3 d-flex justify-content-center align-items-center">
        <form
          className="p-4 border rounded shadow-sm bg-light w-100"
          style={{ maxWidth: "750px" }}
          onSubmit={handleSubmit}
        >
          {/* Employee Name Dropdown */}
          <div className="row mb-3">
            <label
              htmlFor="employeeId"
              className="col-sm-4 col-form-label custom-label"
            >
              Employee Name*:
            </label>
            <div className="col-sm-7">
              <select
                className="form-control"
                id="employeeId"
                name="employeeId"
                value={formData.employeeId}
                onChange={handleChange}
              >
                <option value="">Select Employee</option>
                {employeelist.map((emp) => (
                  <option key={emp.id} value={emp.id}>
                    {emp.fullName}
                  </option>
                ))}
              </select>
              {errors.employeeId && (
                <small className="text-danger">{errors.employeeId}</small>
              )}
            </div>
          </div>

          {/* Property Name */}
          <div className="row mb-3">
            <label
              htmlFor="property"
              className="col-sm-4 col-form-label custom-label"
            >
              Property Name*:
            </label>
            <div className="col-sm-7">
              <input
                type="text"
                className="form-control"
                id="property"
                name="property"
                placeholder="Property Name"
                value={formData.property}
                onChange={handleChange}
              />
              {errors.property && (
                <small className="text-danger">{errors.property}</small>
              )}
            </div>
          </div>

          {/* Date of Transaction */}
          <div className="row mb-3">
            <label
              htmlFor="dateoftransaction"
              className="col-sm-4 col-form-label custom-label"
            >
              Date of Transaction*:
            </label>
            <div className="col-sm-7">
              <input
                type="date"
                className="form-control"
                id="dateoftransaction"
                name="dateoftransaction"
                value={formData.dateoftransaction}
                onChange={handleChange}
              />
              {errors.dateoftransaction && (
                <small className="text-danger">
                  {errors.dateoftransaction}
                </small>
              )}
            </div>
          </div>

          {/* Total Wallet Amount Available */}
          <div className="row mb-3">
            <label
              htmlFor="totalwalletamountavailable"
              className="col-sm-4 col-form-label custom-label"
            >
              Total Wallet Amount Available*:
            </label>
            <div className="col-sm-7">
              <input
                type="number"
                className="form-control"
                id="totalwalletamountavailable"
                name="totalwalletamountavailable"
                value={formData.totalwalletamountavailable}
                readOnly
              />
            </div>
          </div>

          {/* Add Amount to Wallet */}
          <div className="row mb-3">
            <label
              htmlFor="addamounttowallet"
              className="col-sm-4 col-form-label custom-label"
            >
              Add Amount to Wallet*:
            </label>
            <div className="col-sm-7">
              <input
                type="number"
                className="form-control"
                id="addamounttowallet"
                name="addamounttowallet"
                placeholder="Add Amount to Wallet"
                value={formData.addamounttowallet}
                onChange={handleChange}
              />
              {errors.addamounttowallet && (
                <small className="text-danger">
                  {errors.addamounttowallet}
                </small>
              )}
            </div>
          </div>

          {/* Note */}
          <div className="row mb-3">
            <label htmlFor="note" className="col-sm-4 col-form-label custom-label">
              Note:
            </label>
            <div className="col-sm-7">
              <input
                type="text"
                className="form-control"
                id="note"
                name="note"
                placeholder="Note"
                value={formData.note}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Submit Button */}
          <div className="wallet_btn text-center">
            <button type="submit" className="custom-btn">
              Submit
            </button>
          </div>
        </form>
      </div>
    </Base>
  );
};

export default AddEmployeewalletamount;
